<template>
  <div>
    <!-- 页面标题，返回按钮 -->
    <h3>
      <el-page-header @back="$router.push('../list')" :content="title" />
    </h3>
    <!-- 页面主体卡片 -->
    <el-card style="min-height: 750px">
      <el-row :gutter="20">
        <!-- 左侧表单信息 -->
        <el-col :span="4">
          <plan-form
            ref="form"
            @preview-clear="previewClear"
            @preview-fill="previewFill"
          />
        </el-col>
        <!-- 右侧日程图或流程表 -->
        <el-col :span="20">
          <el-tabs v-model="activeTab" v-show="!working">
            <el-tab-pane label="按日历查看" name="calendar">
              <plan-calendar ref="calendar" @work="work" />
            </el-tab-pane>
            <el-tab-pane label="按阶段查看" name="tree">
              <plan-tree ref="tree" />
            </el-tab-pane>
          </el-tabs>
          <plan-work
            ref="work"
            v-if="working"
            :landId="landId"
            @quit="quitWork"
          />
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import PlanForm from './PlanDetailForm.vue'
import PlanCalendar from './PlanDetailCalendar.vue'
import PlanTree from './PlanDetailTree.vue'
import PlanWork from './PlanDetailWork.vue'
import { getPlanByLand } from '@/api/plan2.js'
export default {
  name: 'PlanDetail',
  components: { PlanForm, PlanCalendar, PlanTree, PlanWork },
  data() {
    return {
      /**
       * 是否进入生产任务编辑状态
       */
      working: false,
      /**
       * 当前地块目前是否已经有种植计划
       */
      planning: false,
      /**
       * 右侧活动页签的名字
       */
      activeTab: 'calendar',
      planId:''
    }
  },
  watch:{
    activeTab:function (val) {
      if(val=='tree'){
        console.log('切换tree')
        this.$refs.tree.init(this.planId)

      }
    }
  },
  computed: {
    /**
     * 当前地块id
     */
    landId() {
      return parseInt(this.$route.params.id)
    },
    /**
     * 页面标题
     */
    title() {
      if (this.planning) {
        return '地块生产计划安排'
      } else {
        return '地块空闲，新增种植计划'
      }
    },
  },
  mounted() {
    // 组件加载后立即初始化
    const { landId } = this
    // 根据地块id查询其种植计划
    console.log('地块编号',landId)
    getPlanByLand(landId).then((resp) => {
      const plan = resp.data
      console.log(`地块#${landId}的种植计划:: `, plan)

      this.planning = typeof plan.planId === 'number'
      // 把种植计划传给表单子组件
      this.$refs.form.setPlan(plan)

      // 把种植计划传给日程表子组件
      this.$refs.calendar.setPlan(plan)
     this.planId=plan.planId
    })
  },
  methods: {
    quitWork() {
      this.working = false
    },
    /**
     * 从日历组件中派发的事件响应，表示要启动某一天的生产计划编辑
     */
    work(obj) {
      // obj内容为{date,suggest}
      this.working = true
      this.$nextTick(() => {
        this.$refs.work.setDate(obj.date)
        this.$refs.work.setSuggest(obj.suggest)
      })
    },
    /**
     * 表单发出的事件响应方法，表单中日期或方案至少有一个为空，会清空日程表
     */
    previewClear() {
      this.$refs.calendar.clear()
    },
    /**
     * 表单发出的事件响应方法，表单预生成了种植方案（阶段和建议），可以转发给日程表，让日程表显示
     */
    previewFill(val) {
      this.$refs.calendar.setPhases(val.phases)
      this.$refs.calendar.setSuggests(val.suggests)
    },
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  },
}
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/product/plan/PlanDetail.vue